import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { loginUser } from "../store/users/action";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useCookies } from "react-cookie";

interface PropsFromState {
    login: boolean;
    errors: string;
}

interface propsFromDispatch {
    loginUser: (userData: any, setCookie: any) => any;
}

interface IProps {
    isLoginOpen: boolean;
    closeHandler: () => any;
}

type AllProps = IProps & PropsFromState & propsFromDispatch;

const Login: React.FC<AllProps> = ({
    isLoginOpen,
    closeHandler,
    login,
    errors,
    loginUser
}) => {
    useEffect(() => {
    }, []);

    const intl = useIntl();
    const [values, setValues] = useState({ username: undefined, password: undefined });
    const [, setCookie] = useCookies();

    const handleChange = (e: any) => {
        e.persist();
        setValues(values => ({
            ...values,
            [e.target.name]: e.target.value
        }));
    };

    const loginHandler = async () => {
        const userData = {
            username: values.username,
            password: values.password,
        };
        loginUser(userData, setCookie);
    }

    return (
        <Dialog open={isLoginOpen && !login} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title"><FormattedMessage id="login" /></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage id="login.description" />
          </DialogContentText>
                <TextField
                    margin="dense"
                    name="username"
                    onChange={handleChange}
                    value={values.username}
                    label={intl.formatMessage({ id: "register.email" })}
                    type="email"
                    fullWidth
                />
                <TextField
                    margin="dense"
                    name="password"
                    onChange={handleChange}
                    value={values.password}
                    label={intl.formatMessage({ id: "login.password" })}
                    type="password"
                    fullWidth
                />
                {errors ? (
                    <DialogContentText color="error">
                        <FormattedMessage id={errors} />
                    </DialogContentText>
                ) : null}
            </DialogContent>
            <DialogActions>
                <Button onClick={closeHandler} color="secondary">
                    <FormattedMessage id="cancel" />
                </Button>
                <Button onClick={loginHandler} color="secondary">
                    <FormattedMessage id="login" />
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = ({ user }: ApplicationState) => ({
    login: user.login,
    errors: user.errors
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        loginUser: (userData: any, setCookie: any) => {
            dispatch(loginUser(userData, setCookie));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
